import { useLabelVersion } from '../../../../../../features/labels/LabelsProvider';
import { labelCentro } from '../../../../../../features/labels/labels';
import React, { useState, useEffect } from "react";

import { useServer } from "../../../../../../context/ServerContext";
import { getNanooxClockParts } from "../../nanooxDateTime";

import { fetchConsolidadoCenters,  } from "../../../../services/nanooxService";


// import DrawerNanoox from './DrawerNanoox'; 
import DrawerNanoox from './DrawerNanoox'
import CustomModal from "../../ui/CustomModal";
import CustomTooltip from "../../ui/CustomTooltip";
// import { useTooltipMode } from "../../context/TooltipModeContext";
import HistorialControl from "./HistorialControl";
import ModalCalendario from "./ModalCalendario";
import { GeneratorsStatus } from "./Generators";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ConsoleMessagesModal from "./ConsoleMessagesModal";
import LanguageSelector from "../../../../../../components/LanguageSelector";
// import SettingsIcon from "@mui/icons-material/Settings"; // ícono
import SignalWifiOffIcon from "@mui/icons-material/SignalWifiOff";
import ElectricMeterIcon from '@mui/icons-material/ElectricMeter';
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ViewInArIcon from '@mui/icons-material/ViewInAr';

import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import Logo from '../../../../assets/img/ITG-Logotipo-SobreNegro.png'
import LogoNanoox from '../../../../assets/img/APP_Nanoox_sin fondo.png'
import "./LastMeasurement.css";   // tu CSS existente para el reloj
import "./AppBarNanoox.css";        // NUEVO CSS sin MUI


// const LogoNanoox = `${process.env.PUBLIC_URL}/img/APP_Nanoox_sin fondo.png`;

// const Logo =  `${process.env.PUBLIC_URL}/img/ITG-Logotipo-SobreNegro.png`;


// const data = [
//   { FSM: "FSM_O2", STATE: "IDLE", O2_BAND: "[1 - 2]", O2: "[9.23, 10.0]", ON: 0, WARMED: 0, TIMER_RUNNING: false, timestamp: "2025-09-05 16:45:48", MODE: true, digital_outputs_state: "00" },
//   { FSM: "FSM_O2", STATE: "IDLE", O2_BAND: "[1 - 2]", O2: "[10.0, 10.0]", ON: 0, WARMED: 0, TIMER_RUNNING: false, timestamp: "2025-09-05 16:45:48", MODE: true, digital_outputs_state: "00" }
// ];

function formatName(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function t(translate, key, fallback) {
  const value = typeof translate === "function" ? translate(key) : undefined;
  return value && value !== key ? value : fallback;
}

function normalizeEstadoCentro(value) {
  const normalized = String(value ?? "").trim().toUpperCase();
  return normalized || null;
}

function normalizeCenterName(value) {
  return String(value ?? "").trim().toLowerCase();
}

function getStoredCenterEstado(centerName) {
  if (typeof window === "undefined" || !centerName) {
    return null;
  }

  try {
    const centers = JSON.parse(window.localStorage.getItem("listCenter") || "[]");
    if (!Array.isArray(centers)) return null;

    const selectedName = normalizeCenterName(centerName);
    const center = centers.find(
      (item) => normalizeCenterName(item?.centro) === selectedName
    );

    return center?.estado_centro ?? center?.estado ?? null;
  } catch {
    return null;
  }
}

function getStoredCentroKey() {
  if (typeof window === "undefined") {
    return null;
  }

  const centro = window.localStorage.getItem("CENTRO") || "";
  const area = window.localStorage.getItem("AREA") || "";
  const region = window.localStorage.getItem("REGION") || "";

  if (!centro || !area || !region) {
    return null;
  }

  return `${centro}-${area}-${region}`;
}

export default function AppBarNanoox({
  lastUpdate,
  generadores,
  toggleTheme,
  historialControl,
  controlType,
  estado,
  notificationOpen,
  setNotification_open,
  setNotification_msg,
  setNotification_status,
  page, setPage, modulos,totalPages, nextPage, prevPage,password,setPassword, userLevel,
  version,
  translate ,handleClick ,openMenuIdioma ,handleCloseIdioma ,handleLanguageChange, idioma,
  onSelectCenter, setLoadingCenter, setShowDashboard, VoIoGlobal, medicionesGlobal,
  onSelectGeneratorView, activeView, onViewChange, hasComapGenerators = false,
}) {
  useLabelVersion();

  const { servidor } = useServer();

  const [data, setData] = useState(null);

  // console.log('data',data)

  // const { mode, setMode } = useTooltipMode();
  const [openModal, setOpenModal] = useState(false); // calendario
  const [open, setOpen] = useState(false);
  const [openAuth, setOpenAuth] = useState(false);

  const [selectedCentro, setSelectedCentro] = useState(() => getStoredCentroKey()); //  centro seleccionado en el drawer
  const nombreCentro = selectedCentro?.split("-")?.[0];

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  //  * --------------------------handle MouseEnter
  const handleLogoMouseEnter = () => {
    setOpen(true); 
  };
    
  const handleLogoMouseLeave = () => {
      setOpen(false); 
  };



  const [openConsoleModal, setOpenConsoleModal] = useState(false);
  const [error, setError] = useState("");
  const [notif, setNotif] = useState({ open: false, msg: "", severity: "success", time: 1500 });
  const total = modulos?.length || 0;


  const currentTime = lastUpdate;
  const { date: rawDate, time } = getNanooxClockParts(currentTime, idioma);
  const capitalizedDate = rawDate
    .split(" ")
    .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : ""))
    .join(" ");
  
    // console.log('userLevel', userLevel)
  const isDisconnected = (() => {
    if (!lastUpdate) return true; // si no hay datos, consideramos desconectado
    const updateTime = new Date(lastUpdate);
    const now = new Date();
    const diffMs = now - updateTime; // diferencia en milisegundos
    const diffMins = diffMs / 1000 / 60;
    return diffMins >= 40;
  })();
    
  const handleAuth = () => {
    if (userLevel === 1) {
      // window.location.href = "/settings"; // ✅ redirige a settings
      setShowDashboard(true)
    } else if (password.toLowerCase() === "wk") {
      toggleTheme(); // ✅ activa el otro modo
      setOpenAuth(false); // cerrar modal
      setPassword("");
      setError("");
    } else if (userLevel >= 1 ) {
      // ✅ guardar contraseña en localStorage
      localStorage.setItem("authPassword", password);

      // cerrar modal
      setOpenAuth(false);
      // setPassword("");
      setError("");
    } else {
      setError("Credenciales inválidas");
    }
  };

  // Nombre del centro seleccionado
  const [centerName, setCenterName] = useState(localStorage.getItem("CENTRO") || "");

  const estadoColorMap = {
    B: "#16a34a", // verde
    A: "#facc15", // amarillo
    C: "#dc2626", // rojo
  }

  function getEstadoByCenterName(data, centerName) {
    if (!data?.centros || !centerName) return null

    for (const area of Object.values(data.centros)) {
      if (!area) continue

      for (const [fullName, center] of Object.entries(area)) {
        if (normalizeCenterName(fullName.split("-")[0]) === normalizeCenterName(centerName)) {
          return center?.estado_centro ?? center?.estado ?? null
        }
      }
    }

    return null
  }

  const estadoDesdeProps = normalizeEstadoCentro(estado);
  const estadoDesdeConsolidado = normalizeEstadoCentro(
    getEstadoByCenterName(data ?? {}, centerName)
  );
  const estadoDesdeStorage = normalizeEstadoCentro(getStoredCenterEstado(centerName));
  const estadoActual = estadoDesdeProps || estadoDesdeConsolidado || estadoDesdeStorage;
  const color = estadoColorMap[estadoActual] ?? "#9ca3af";
  const statusClass =
    estadoActual === "B"
      ? "green"
      : estadoActual === "A"
      ? "yellow"
      : estadoActual === "C"
      ? "red"
      : "unknown";


  // console.log('centerName', centerName)

  useEffect(() => {
    const handleStorageChange = () => {
      setCenterName(localStorage.getItem("CENTRO") || "");
      setSelectedCentro(getStoredCentroKey());
    };

    // escuchar cambios en localStorage (cuando Drawer guarda)
    window.addEventListener("storage", handleStorageChange);

    // inicializar al montar
    handleStorageChange();

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const nextCenterName = selectedCentro?.split("-")?.[0];
    if (nextCenterName) {
      setCenterName(nextCenterName);
    }
  }, [selectedCentro]);

  useEffect(() => {
    const fetchData = async () => {
        const PAGE ='NANOOX' 
        const result = await fetchConsolidadoCenters(PAGE,servidor);
        setData(result);
    };

    // Fetch data initially
    fetchData();

    // Set interval to fetch data every 60 seconds
    const interval = setInterval(fetchData, 60000);

    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);

  let mensaje = "";


  const PropsCalendario = {
    translate ,handleClick ,openMenuIdioma ,handleCloseIdioma ,handleLanguageChange, idioma,
  }

    const MyDrawerProps = {
    translate,
    open:open,
    setOpen:setOpen,
    toggleDrawer:toggleDrawer,
    handleLogoMouseEnter:handleLogoMouseEnter, 
    handleLogoMouseLeave:handleLogoMouseLeave,
    onSelectCenter, version,
    selectedCentro, setSelectedCentro,
    setLoadingCenter
  } 

  return (
    <header className="appbar">
      <div className="toolbar">
        {/* IZQUIERDA */}
        <div className="left-row">
          {/* Logo ITG */}
          <img  src={Logo} alt="ITG" className="logo-itg"  onClick={toggleDrawer(true)}   onMouseEnter={() => handleLogoMouseEnter()}
                  onMouseLeave={() => handleLogoMouseLeave()} />

          <CustomTooltip
            variant={'pipeline'}
            title={translate("inicio")}
            // title={t("drawer.views.nanoox.label")}
            color={'#c3c3c3'}
            arrow
          >
            <button
              type="button"
              className={`icon-btn ${activeView === "nanoox" ? "is-active" : ""}`}
              onClick={() => onViewChange?.("nanoox")}
              aria-label={t("drawer.views.nanoox.label")}
            >
              <HomeRoundedIcon className="icon" />
            </button>
          </CustomTooltip>
          <CustomTooltip
            variant={'pipeline'}
            title={translate("nanoox3d")}
            // title={t("drawer.views.nanoox3d.label")}
            color={'#c3c3c3'}
            arrow
          >
            <button
              type="button"
              className={`icon-btn ${activeView === "nanoox3d" ? "is-active" : ""}`}
              onClick={() => onViewChange?.("nanoox3d")}
              aria-label={t("drawer.views.nanoox3d.label")}
            >
              <ViewInArIcon className="icon" />
            </button>
          </CustomTooltip>
          <CustomTooltip
            variant={'pipeline'}
            title={translate("vpsa_o2")}
            // title={t("drawer.views.generador-o2-3d.label")}
            color={'#c3c3c3'}
            arrow
          >
            <button
              type="button"
              className={`icon-btn ${activeView === "generador-o2-3d" ? "is-active" : ""}`}
              onClick={() => onViewChange?.("generador-o2-3d")}
              // aria-label={t("drawer.views.generador-o2-3d.label")}
              aria-label={translate("vpsa_o2")}
            >
              <OxygenGeneratorIconCompact className="icon" width="2.5vw" height="2.5vw"  />
            </button>
          </CustomTooltip>

          {/* Vista de generador COMAP: los iconos de GeneratorsStatus dependen de
              los generadores FSM antiguos, que un centro COMAP puro no tiene. */}
          {hasComapGenerators && (
            <CustomTooltip
              variant={'pipeline'}
              title={translate("generator")}
              color={'#c3c3c3'}
              arrow
            >
              <button
                type="button"
                className={`icon-btn ${activeView === "generar" ? "is-active" : ""}`}
                onClick={() => onViewChange?.("generar")}
                aria-label={translate("generator")}
              >
                <ElectricMeterIcon className="icon" />
              </button>
            </CustomTooltip>
          )}


          {/* Botón calendario */}
          <CustomTooltip
            variant={'pipeline'}
            title={translate("reportes")}
            color={'#c3c3c3'}
            arrow
          >
            <button
              type="button"
              className="icon-btn"
              onClick={() => setOpenModal((v) => !v)}
              aria-label={t(translate, "open_calendar", "Abrir calendario")}
              // title="Calendario"
            >
              <CalendarMonthIcon className="icon" />
            </button>
          </CustomTooltip>
          {/* Historial */}
            <HistorialControl historialControl={historialControl}  translate={translate}/>

            <ParametrosElectricos VoIoGlobal={VoIoGlobal} medicionesGlobal={medicionesGlobal} userLevel={userLevel} iconSrc={ElectricalServicesIcon} translate={translate}/>

          {/* Toggle Simple / Detallada */}
{/* 
          <CustomTooltip
            variant={'pipeline'}
            title={translate('tipo_vista')}
            color={'#c3c3c3'}
            arrow
          >
            <div className="toggle-group" role="group" aria-label="Modo de visualización">
              <button
                type="button"
                className={`toggle-btn ${mode === "simple" ? "selected" : ""}`}
                onClick={() => setMode("simple")}
              >
                {translate('simple')}
              </button>
              <button
                type="button"
                className={`toggle-btn ${mode === "detailed" ? "selected" : ""}`}
                onClick={() => setMode("detailed")}
              >
                {translate('detallada')}
              </button>
            </div>
          </CustomTooltip> */}

          {/* Indicador de estado (pulso) */}
          <CustomTooltip
            variant={'pipeline'}
            title={t(translate, "center_status", "Estado del Centro")}
            color={'#c3c3c3'}
            arrow
          >
            <div style={{backgroundColor: color}} className={`estado-indicator ${statusClass === "green" ? "estable" : "inestable"}`}  >
                <div style={{backgroundColor: color}}  className={`estado-circle ${statusClass}`}>
                    <div className="pulse"></div>
                </div>
            </div>          
          </CustomTooltip>
          {/* Botón configuración consola */}
          {/* <button
            type="button"
            className="icon-btn"
            onClick={() => setOpenConsoleModal(true)}
            aria-label="Configurar consola"
            title="Configurar consola"
          >
            <SettingsIcon className="icon" />
          </button> */}
          {/* Cambio de pagina de modulos */}
          {total > 2 && (
            <CustomTooltip
              variant="pipeline"
              title={t(translate, "module_pages", "Paginas por Modulo")}
              color="#c3c3c3"
              arrow
            >
              <div className="pagination-controls">
                <button onClick={prevPage}>
                  {t(translate, "previous", "Anterior")}
                </button>
                <span>
                  {t(translate, "page_of", "Pagina {page} de {total}")
                    .replace("{page}", page + 1)
                    .replace("{total}", totalPages)}
                </span>
                <button onClick={nextPage}>
                  {t(translate, "next", "Siguiente")}
                </button>
              </div>
            </CustomTooltip>
          )}

           {/* Nombre del centro */}
          {centerName && (
            <span className="center-name-appbar">
              {translate('accessed_center')}<br />{labelCentro({ region: localStorage.getItem('REGION'), area: localStorage.getItem('AREA'), centro: nombreCentro || centerName }, formatName(nombreCentro) || formatName(centerName))}
            </span>
          )}
        </div>

        {/* DERECHA */}
        <div className="right-row">

          <LanguageSelector translate={translate} />
          {/* Generadores */}
          <div className="gens-wrap">
            <GeneratorsStatus items={generadores} translate={translate} onSelectGenerator={onSelectGeneratorView} />
            <small className="gens-msg">{mensaje}</small>
          </div>

          {/* Reloj */}
          <div className="clock-box-nanoox">
            <div className="clock-container-nanoox">
              <div className="last-measurement-nanoox">
                {/* <div>Última</div>
                <div>Medición</div> */}
                {translate('ultima_medicion')}
                <div></div>
              </div>
              <div className="main-clock-nanoox">
                <div className="days-row-nanoox">
                  <div>{capitalizedDate}</div>
                </div>
                <div className="time-display-nanoox">{time}</div>
              </div>
               {isDisconnected && (
                <CustomTooltip
                  variant="pipeline"
                  title={t(translate, "disconnected_last_measurement", "Desconectado: ultima medicion hace mas de 40 min")}
                  color="#c3c3c3"
                  arrow
                >
                    <SignalWifiOffIcon aria-label={t(translate, "disconnected", "Desconectado")}  style={{ color: "#ff6b6b",fontSize:'1vw', position:'absolute', top:'0.5vh', right:'0.7vw' }} />
                </CustomTooltip>
              )}
            </div>
          </div>
        
          {/* Logo Nanoox (abre auth) */}
          <img
            src={LogoNanoox}
            alt="Nanoox"
            className="logo-nanoox"
            onClick={() => setShowDashboard(true)}
            role="button"
            tabIndex={0}
          />
        </div>
      </div>


      {/* MODAL Calendario */}
      <ModalCalendario
        openModal={openModal}
        setOpenModal={setOpenModal}
        controlType={controlType}
        notif={notif}
        setNotif={setNotif}
        // 
        // controlType 
        // openModal 
        // setOpenModal 
        notificationOpen={notificationOpen}
        setNotification_open={setNotification_open}
        setNotification_msg={setNotification_msg}
        setNotification_status={setNotification_status}
        {...PropsCalendario}
      />

      {/* MODAL Autenticación */}
      <CustomModal
        open={openAuth}
        onClose={() => {
          setOpenAuth(false);
          setPassword("");
          setError("");
        }}
        title={t(translate, "configuration_access", "Acceso a Configuracion")}
        actions={[
          {
            label: t(translate, "accept_button", "Ingresar"),
            onClick: handleAuth,
          },
        ]}
      >
        <div className="auth-form">
          <label className="label" htmlFor="pwd">
            {t(translate, "password", "Contrasena")}
          </label>
          <input
            id="pwd"
            type="password"
            className="input-user-nanoox"
            value={password || ""}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="********"
          />
          {error && <p className="error-text">{error}</p>}
        </div>
      </CustomModal>

      {/* MODAL Configuración consola */}
      <ConsoleMessagesModal
        open={openConsoleModal}
        onClose={() => setOpenConsoleModal(false)}
      />

      <DrawerNanoox  {...MyDrawerProps} />
    </header>
  );
}



const ParametrosElectricos = ({ VoIoGlobal, medicionesGlobal, userLevel, translate }) => {

  const jaulasDetalle = React.useMemo(() => {
    const lista = [];
    (VoIoGlobal?.porModulo ?? []).forEach((m) => {
      (m?.jaulas ?? []).forEach((j) => {
        if (typeof j.voltaje === "number" && typeof j.corriente === "number") {
          lista.push({
            alias: j.alias || t(translate, "no_alias", "Sin alias"),
            voltaje: j.voltaje,
            corriente: j.corriente,
          });
        }
      });
    });
    return lista;
  }, [VoIoGlobal, translate]);

  const jaulasDetalleMediciones = React.useMemo(() => {
    const lista = [];
    (medicionesGlobal?.porModulo ?? []).forEach((m) => {
      (m?.jaulas ?? []).forEach((j) => {
        if (typeof j.Start === "boolean" && typeof j.Start_Valv === "boolean" && typeof j.Status === "number") {
          lista.push({
            alias: j.alias || t(translate, "no_alias", "Sin alias"),
            Start: j.Start,
            Start_Valv: j.Start_Valv,
            Status:    j.Status
          });
        }
      });
    });
    return lista;
  }, [medicionesGlobal, translate]);

  return (
    <div className="electricalCard ui-voltage">
      <div className="electrical-main ui-chip">
        {/* Ícono del medidor */}
          <ElectricMeterIcon className="ui-electric-icon"/>
      </div>

      {/* Panel que baja con hover */}
      <div className={`electrical-panel ${userLevel > 1 ? 'visble' : 'not'}`}>
        <div>
            <div className="upper">
              <div className="tooltip-title">{t(translate, "voltage_and_current", "Voltaje y Corriente")}</div>
            </div>
            <div className="lower list electrical">
              {jaulasDetalle.length === 0 ? (
                <div className="row">{t(translate, "no_data", "Sin datos")}</div>
              ) : (
                jaulasDetalle.map((j, i) => (
                  <div className="row" key={`${j.alias}-${i}`}>
                    <span className="alias">{j.alias}</span>
                    <span className="temp">
                      {j.voltaje.toFixed(2)} V / {j.corriente.toFixed(2)} A
                    </span>
                  </div>
                ))
              )}
            </div>
        </div>
        <div>
          <div className="upper">
            <div className="tooltip-title">{t(translate, "measurements", "Mediciones")}</div>
          </div>
          <div className={`lower list medicion ${userLevel > 1 && 'visble'}`}>
            {jaulasDetalleMediciones.length === 0 ? (
              <div className="row">{t(translate, "no_data", "Sin datos")}</div>
            ) : (
              jaulasDetalleMediciones.map((j, i) => {
                // console.log('j',j)
                return(
                <div className="row" key={`${j.alias}-${i}`}>
                  <span className="alias">{j.alias}</span>
                  {/* <span className="temp">{j.Start !== null ? j.Start.toString() : "--"}</span> */}
                  {/* <span className="temp">{j.Start_Valv !== null ? j.Start_Valv.toString() : "--"}</span> */}
                  <div style={{display:'flex', justifyContent:'center', alignContent:'center', alignItems:'center', gap:'0.4vw' }}>
                    <PumpIcon status={j.Start} />
                    <IconoValvula status={j.Start_Valv} />
                  </div>
                 {userLevel > 1 && <span
                      title={j.Status !== null ? j.Status : "--"}
                      style={{  fontSize:'0.8vw', //borderRadius:'50%', 
                              //width:'7vw', background:'#5f5f5f',
                              textAlign:'center', alignContent:'center', 

                       }}>
                        {STATUS_MAP[j.Status] ?? t(translate, "unknown_status", "Unknown status")} 
                  </span>}
                </div>
              )})
            )}
          </div>
        </div>
      </div>
    </div>

  );
};

const STATUS_MAP = {
  0: "Absence of power",
  1: "Preheating",
  2: "Starter ready",
  3: "Start delay",
  4: "Kick start",
  5: "Acceleration ramp",
  6: "Current limit",
  7: "Torque limit",
  8: "Run",
  9: "Bypass closed",
  10: "Deceleration ramp",
  11: "Protections inhibited",
  12: "Freewheel",
  13: "Alarm",
  14: "Motor selection",
};


function PumpIcon({ status  }) {
  return (
    <div className={`pump-icon ${status ? "green" : "gray"}`}>
      <svg
        viewBox="0 0 100 100"
        className="pump-svg"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Color dinámico del fondo */}
        <circle className="pump-bg" cx="50" cy="50" r="48" />

        <g
          className="pump-stroke"
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="miter"
          transform="translate(-10, -2.5)" 
        >
          <rect x="50" y="38" width="30" height="24" rx="3" ry="6" />

          <path d="M54 61 V39" />

          <line x1="55" y1="42" x2="75" y2="42" />
          <line x1="55" y1="46" x2="75" y2="46" />
          <line x1="55" y1="50" x2="75" y2="50" />
          <line x1="55" y1="54" x2="75" y2="54" />
          <line x1="55" y1="58" x2="75" y2="58" />

          <path d="M76 61 V39" />

          <path d="M50 40 H46" />
          <path d="M50 59 H36" />
          <path d="M45 49 V31" />
          <path d="M50 59 V40" />
          <path d="M36 31 V59" />

          <rect x="27" y="45" width="8" height="9" />
          <rect x="31.5" y="26" width="18" height="4" />
          <rect x="24" y="42" width="3" height="15" />
        </g>
      </svg>
    </div>
  );
}


const IconoValvula = ({ status  }) => {
  return (
    <div  className="icono-valvula-container">
      <svg
        viewBox="0 0 200 200"
        className="icono-valvula-svg"
        aria-hidden="true"
      >
        {/* Círculo de fondo */}
        <circle cx="100" cy="100" r="98" className={`icono-bg ${status ? "green" : "gray"}`}  />

        {/* Cuadrado superior */}
        <rect
          x="75"
          y="35"
          width="50"
          height="50"
          className="icono-trazo"
        />

        {/* Línea del cuadrado al centro */}
        <line
          x1="100"
          y1="85"
          x2="100"
          y2="115"
          className="icono-trazo"
        />

        {/* Triángulo izquierdo (punta hacia el centro) */}
        <polygon
          points="70,110 70,150 100,130"
          className="icono-trazo"
        />

        {/* Triángulo derecho (punta hacia el centro) */}
        <polygon
          points="130,110 130,150 100,130"
          className="icono-trazo"
        />

        {/* Barras verticales a los lados */}
        <line
          x1="62"
          y1="110"
          x2="62"
          y2="150"
          className="icono-trazo"
        />
        <line
          x1="138"
          y1="110"
          x2="138"
          y2="150"
          className="icono-trazo"
        />

        {/* Líneas horizontales izquierda y derecha */}
        <line
          x1="20"
          y1="130"
          x2="62"
          y2="130"
          className="icono-trazo"
        />
        <line
          x1="138"
          y1="130"
          x2="180"
          y2="130"
          className="icono-trazo"
        />
      </svg>
    </div>
  );
};



  function OxygenGeneratorIconCompact({
    width = "2.2vw",
    height = "2.2vw",
    className = "",
  }) {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-label="Icono generador de oxígeno VPSA"
        fill="none"
      >
        <rect x="28" y="92" width="72" height="10" rx="4" fill="currentColor" />

        <rect x="34" y="34" width="18" height="54" rx="9" fill="currentColor" />
        <rect x="38" y="28" width="10" height="8" rx="2" fill="currentColor" />

        <rect x="76" y="34" width="18" height="54" rx="9" fill="currentColor" />
        <rect x="80" y="28" width="10" height="8" rx="2" fill="currentColor" />

        <path
          d="M52 42 H64 H76"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
        />

        <path
          d="M43 88 V78 H85 V88"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <rect x="55" y="54" width="18" height="24" rx="8" fill="currentColor" />

        <rect x="40" y="44" width="6" height="20" rx="3" fill="#26323F" opacity="0.95" />
        <rect x="82" y="58" width="6" height="20" rx="3" fill="#26323F" opacity="0.95" />

        <path
          d="M58 18 C52 14, 46 14, 42 18"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path d="M41 18 L44 14 L45 20 Z" fill="currentColor" />

        <path
          d="M70 18 C76 14, 82 14, 86 18"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <path d="M87 18 L84 14 L83 20 Z" fill="currentColor" />

        <circle cx="64" cy="67" r="11" fill="#26323F" />
        <text
          x="61"
          y="71"
          textAnchor="middle"
          fill="currentColor"
          fontSize="12"
          fontWeight="700"
          fontFamily="Arial, Helvetica, sans-serif"
        >
          O
        </text>
        <text
          x="70"
          y="67"
          textAnchor="middle"
          fill="currentColor"
          fontSize="8"
          fontWeight="700"
          fontFamily="Arial, Helvetica, sans-serif"
        >
          2
        </text>

        <path
          d="M73 66 H92"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <circle cx="96" cy="66" r="4" fill="currentColor" />
      </svg>
    );
  }
//   return (
//     <svg
//       width={width}
//       height={height}
//       viewBox="0 0 128 128"
//       xmlns="http://www.w3.org/2000/svg"
//       className={className}
//       aria-label="Ícono generador de oxígeno"
//       role="img"
//     >
//       <circle cx="64" cy="64" r="50" fill="#bbbbbb" />

//       <rect x="52" y="110" width="13" height="50" fill="#bbbbbb" />
//       <rect x="71" y="110" width="13" height="50" fill="#bbbbbb" />

//       {/* <rect x="45" y="49" width="38" height="30" rx="15" fill="#26323F" /> */}

//       <text
//         x="60"
//         y="80"
//         textAnchor="middle"
//         dominantBaseline="middle"
//         fill="#26323F"
//         fontSize="52"
//         fontWeight="900"
//         fontFamily="Arial, Helvetica, sans-serif"
//       >
//         O
//       </text>

//       <text
//         x="89"
//         y="60"
//         textAnchor="middle"
//         fill="#26323F"
//         fontSize="32"
//         fontWeight="900"
//         fontFamily="Arial, Helvetica, sans-serif"
//       >
//         2
//       </text>
//     </svg>
//   );
// }
